<template>
    <TopContainer :showAssignmentScore="false">
        <div class="container">
            <div>
                <center><h1>Je hebt de volgende score gehaald.</h1></center> 
                <div @click.prevent="onTryAgainClicked">OPNIEUW?(TEST KNOP)</div>   
            </div>
        </div>
    </TopContainer>
</template>

<script>
    import be from '../services/Backend';
    import Auth from '../services/Auth';

    //components
    import TopContainer from './TopContainer.vue';

    export default {
        'props': ['assignmentCode'],
        'components': {TopContainer},
        'data': () =>
        {
            return {
            }
        },

        'methods': {
            onTryAgainClicked() {
                this.$router.push({ name: 'loadassignment' });
            },
            onContinueClicked() {
                this.$router.push({ name: 'assignmentgrid' });
            }
        },

        mounted() {
            this.scoreData = {
                incorrect: 0,
                correct: 0, 
                questionCount: 0
            }
            Promise.all([
                be.MIA.getAssignment(this.assignmentCode),
                be.MIA.getAssignmentSessionLatest(this.assignmentCode)
            ]).then(([assignment, session]) => {
                
            });
        }
    };
</script>
